import { DisplayNames } from "../../types";
import { IncidentRow } from "./models";
import { IncidentWebsiteDisplayDetailsRow } from "./types/websiteDisplay";
import { IncidentActivitiesCalendarDetailsRow } from "./types/activitesCalendar";
import { IncidentElectronicPanelsDetailsRow } from "./types/electronicPanels";
import { IncidentFundraiserDetailsRow } from "./types/fundraiser";
import { IncidentInfoRequestDetailsRow } from "./types/infoRequest";
import { IncidentPrismeDetailsRow } from "./types/prisme";
import { IncidentTelevisionDisplayDetailsRow } from "./types/televisionDisplay";
import { IncidentAdmissibilityDetailsRow } from "./types/admissibility";
import { IncidentPublicSpaceDetailsRow } from "./types/publicSpace/publicSpace";
import { IncidentStandardEquipmentDetailsRow } from "./types/standardEquipment";
import { IncidentFilmingDetailsRow } from "./types/specialEvents/filming/filming";
import { IncidentSpecialEventsDetailsGeneralRow } from "./types/specialEvents/specialEventsGeneral";
import { IncidentSpecialEventDetailsRow } from "./types/specialEvents/specialEvent/specialEvent";
import { IncidentSpecialEventsDateBase } from "./types/specialEvents/dates";
import { IncidentPublicSpaceReservationRowBase } from "./types/publicSpace/reservation";

const demandDisplayNames: DisplayNames<IncidentRow> = {
  title: "Sujet de la demande",
  vdl_contactprincipal: "Contact principal",
  vdl_typededemande: "Type de demande",
  vdl_detailsdelademande: "Détails",
  idtypedeservice: "Type de demande",
  incidentid: "",
  ticketnumber: "Numéro de la demande",
  statuscode: "Status",
  modifiedon: "Date de modification",
  createdon: "Date de création",
  _vdl_contactprincipal_value_FormattedValue: "",
  _vdl_contactprincipal_value: "Contact principal",
  _vdl_typededemande_value: "Type de demande",
  _vdl_typededemande_value_FormattedValue: "",
  _parentcaseid_value: "Demande parent",
  incident_parent_incident: "",
};

const infoRequestDisplayNames: DisplayNames<IncidentInfoRequestDetailsRow> = {
  vdl_demandeinformationid: "",
  vdl_sujetdelademande: "Sujet de la demande",
  vdl_name: "",
  vdl_description: "Description de la demande",
};

const filmingDisplayNames: DisplayNames<
  Omit<IncidentFilmingDetailsRow, keyof IncidentSpecialEventsDetailsGeneralRow>
> = {
  vdl_titredelaproduction: "Titre de la production",
  vdl_naturedutournage: "Nature du tournage",
  vdl_tournageetudiant: "Tournage étudiant",
  vdl_resumeduscenarioenquelquesmots: "Résumé du scénario en quelques mots",
  vdl_nombredevehiculesdeproductionetparticuliers: "Nombre de véhicules de production et particuliers",
  vdl_cubes: "Cube(s)",
  vdl_roulottes: "Roulotte(s)",
  vdl_voituresparticuliers: "Voitures particuliers",
  vdl_autresprecisez: "Autres (précisez)",
  vdl_descriptiondesequipementsaetreinstalles: "Description des équipements à être installés",
  vdl_engagementloisetreglementtournage: "Toute demande doit respecter l'ensemble des lois et de la réglementation en vigueur et se conformer aux procédures et directives encadrant la tenue d'un tournage sur le territoire lavallois.",
  vdl_envoidesdocuments2semmaximumavantletournage: "Les documents suivants doivent être transmis au moins deux (2) semaines avant la date prévue du tournage à l'adresse suivante : tournage@laval.ca \n    •certificat d'assurance responsabilité (minimum 2 000 000 $); \n    •lettre d'avis bilingue destinée aux citoyens et citoyennes du secteur ciblé; \n    •plan du site.",
  vdl_engagementapayerlafacture: "Les frais facturés doivent être acquittés avant la date prévue du tournage, conformément à la réglementation en vigueur.",
  vdl_sengageafournirlesjustificatifssurdemande: "Selon la nature du tournage, la municipalité peut exiger une autorisation écrite des citoyens et citoyennes du secteur affecté avant d'accorder son approbation."
};

const standardEquipmentDisplayNames: DisplayNames<IncidentStandardEquipmentDetailsRow & {vdl_adressecompleterecuperation: any; vdl_adressecompletelivraison: any;}> =
  {
    vdl_equipementmunicipalid: "",
    vdl_identiquealadressedelivraison: "Identique à l'adresse de livraison",
    vdl_datedelivraison: "Date de livraison",
    vdl_datederecuperation: "Date de récupération",
    vdl_secteurdeladressederecuperation: "Secteur de l'adresse de récupération",
    vdl_secteurdeladressedelivraison: "Secteur de l'adresse de livraison",
    vdl_remarqueoucommentaire: "Remarque ou commentaire",
    vdl_remarqueoucommentairerecuperation: "Remarque ou commentaire",
    vdl_nomdubatimentrecuperation: "Nom du bâtiment",
    vdl_nomdubatimentlivraison: "Nom du bâtiment",
    products: "Produits",
    _vdl_typedeproduit_value: "Type de produits",
    vdl_horaire: "Horaire de livraison",
    vdl_horairerecuperation: "Horaire de récupération",
    vdl_rue1_livraison: "",
    vdl_rue2_livraison: "",
    vdl_ville1_livraison: "",
    vdl_departementprovince_livraison: "",
    vdl_codepostal1_livraison: "",
    vdl_pays1_livraison: "",
    vdl_rue_recuperation: "",
    vdl_rue2_recuperation: "",
    vdl_ville_recuperation: "",
    vdl_departementprovince_recuperation: "",
    vdl_codepostal_recuperation: "",
    vdl_pays_recuperation: "",
    vdl_adressecompleterecuperation: "Adresse complète",
    vdl_adressecompletelivraison: "Adresse complète",
  };

const fundraiserDisplayNames: DisplayNames<IncidentFundraiserDetailsRow> = {
  vdl_projetdefinancement: "Projet de financement",
  vdl_collectedargentid: "",
  vdl_erjour: "1er choix",
  vdl_emejour: "2e choix",
  vdl_3emejour: "3e choix",
  vdl_4emejour: "4e choix",
  vdl_5emejour: "5e choix",
  vdl_jemengageasuivrelaformationobligatoire:
    "Je m'engage à suivre la formation obligatoire",
  vdl_jaidejasuivilaformationobligatoireannee:
    "J'ai déjà suivi la formation obligatoire (Année)",
  vdl_nombredejeunesparticipants18ansetmoins:
    "Nombre de jeunes qui participeront",
  vdl_nombredadultesparticipants5min: "Nombre d'adultes qui participeront",
  vdl_chomedeycartier: "Chomedey/Cartier",
  vdl_jeanberauddanieljohnson: "Jean-Béraud/Daniel-Johnson",
  vdl_notredamelavatere: "Notre-Dame/Lavatère",
  vdl_stmartinboisdeboulogne: "St-Martin/Bois-De-Boulogne",
  vdl_engagementaurespectdesproceduresetdirectives:
    "En tant que responsable de l'activité, je m'engage à faire respecter les procédures et directives de la municipalité dont j'ai pris connaissance préalablement et je dégage Ville de Laval de toute responsabilité dans le cadre de cet événement.",
};

const electronicPanelsDisplayNames: DisplayNames<IncidentElectronicPanelsDetailsRow> =
  {
    vdl_soutienpromotionnelid: "",
    vdl_datededebutdelaffichage: "Date de début",
    vdl_datedefindelaffichage: "Date de fin",
    vdl_quoi: "Quoi ?",
    vdl_qui: "Qui ?",
    // vdl_quanddatesetheures: "Quand? Date(s) et heure(s)",
    vdl_ou: "Où ?",
    vdl_telephonepourinformationsurlevenement:
      "Courriel, téléphone ou autres liens pertinents",
  };

const activitiesCalendarDisplayNames: DisplayNames<IncidentActivitiesCalendarDetailsRow> = {
  vdl_soutienpromotionnelid: "",
  vdl_titredelevenement: "Titre de l'événement",
  vdl_lieudelevenement: "Lieu de l'événement",
  vdl_adressecompletedulieudelevenement: "Adresse complète du lieu de l'événement",
  vdl_dateetheurededebut: "Date et heure de début",
  vdl_dateetheuredefin: "Date et heure de fin",
  vdl_commentairessurleshorairesdelevenement: "Commentaires sur l'horaire",
  vdl_cout: "Coût",
  vdl_adultes: "Adultes",
  vdl_retraites: "Retraités",
  vdl_etudiants: "Étudiants",
  vdl_enfants: "Enfants",
  vdl_prixdefamille: "Prix famille",
  vdl_prixdegroupe: "Prix de groupe",
  vdl_autressvpdetaillez2: "Autres, svp détaillez",
  vdl_stationnementpayant: "Stationnement payant",
  vdl_coutdestationnement: "Coût de stationnement",
  vdl_clientelesvisees: "Clientèle(s) visée(s)",
  vdl_siteinternet: "Site internet",
  vdl_pagefacebook: "Page Facebook",
  vdl_courriel: "Courriel",
  vdl_telephonecalendrier: "Téléphone",
  vdl_descriptionsommairedelevenement: "Description sommaire de l'événement",
  vdl_autreinformationpertinente: "Autre information pertinente",
  vdl_piecejointe: "Veuillez joindre un fichier",
  vdl_piecejointe_name: ""
};
const televisionDisplayDisplayNames: DisplayNames<IncidentTelevisionDisplayDetailsRow> =
  {
    vdl_soutienpromotionnelid: "",
    vdl_piecejointe: "Fichier du visuel promotionnel",
    vdl_debutdediffusion: "Début de diffusion",
    vdl_findediffusion: "Fin de diffusion",
    vdl_secteur1: "Secteur 1",
    vdl_secteur2: "Secteur 2",
    vdl_secteur3: "Secteur 3",
    vdl_secteur4: "Secteur 4",
    vdl_secteur5: "Secteur 5",
    vdl_secteur6: "Secteur 6",
    vdl_piecejointe_name: ""
  };
const websiteDisplayDisplayNames: DisplayNames<IncidentWebsiteDisplayDetailsRow> =
  {
    vdl_soutienpromotionnelid: "",
    vdl_lieninternetdelapageconcernee: "Lien internet de la page concernée",
    vdl_piecejointe: "Pièce jointe",
    vdl_piecejointe_name: ""
  };

const prismeDisplayNames: DisplayNames<IncidentPrismeDetailsRow> = {
  vdl_soutienpromotionnelid: "",
  vdl_activiteapromouvoir: "Activité à promouvoir",
  vdl_datedelactivite: "Date de l'activité",
  vdl_nombredepanneaux: "Nombre de site",
  vdl_datededebutdelevenement: "Date de début",
  vdl_datedefindelevenement: "Date de fin",
  vdl_autoroute25bouldelaconcordeestsite3: "Autoroute 25 & boul. de la Concorde Est (Site 3)",
  vdl_monteedumoulinleparcdumoulinsite10: "Montée du Moulin & le parc du Moulin (Site 10)",
  vdl_bouldeslaurentidesboulsaintmartinsite1: "Boul. des Laurentides & boul. Saint-Martin (Site 1)",
  vdl_bouldeslaurentidesboulcartiersite2: "Boul. des Laurentides & boul. Cartier (Site 2)",
  vdl_boullecorbusierbouldusouvenirsite8: "Boul. le Corbusier & boul. du Souvenir (Site 8)",
  vdl_bouldelaconcordebouldelavenirsite9: "Boul. de la Concorde & boul. de l'Avenir (Site 9)",
  vdl_boulcurelabelleboullevesquesite4: "Boul. Curé-Labelle & boul. Lévesque (Site 4)",
  vdl_boularthursauvebouldagenaisouestsite6: "Boul. Arthur-Sauvé & boul. Dagenais Ouest (Site 6)",
  vdl_boulsamsonavjosaphatdemerssite11: "Boul. Samson & av. Josaphat-Demers (Site 11)",
  vdl_bouldeslaurentidesbouldagenaisestsite5: "Boul. des Laurentides & boul. Dagenais Est (Site 5)",
  vdl_piecejointe: "Esquisse de l'affiche",
  vdl_piecejointe_name: ""
};

const admissibilityDisplayNames: DisplayNames<IncidentAdmissibilityDetailsRow> = {
  vdl_admisibiliteid: "",
  vdl_dorganismeabutnonlucratif: "Organisation à but non lucratif",
  vdl_dorganismedebienfaisanceenregistre: "Organisation de bienfaisance enregistré",
  vdl_etesvousunchapitrelavalloisduneinstancepro: "Chapitre lavallois d'une instance provinciale légalement constituée",
  vdl_siouiquelestlenometleneqdelorg: "Quel est le NEQ de l'organisation?",
  vdl_aucuneassurance: "Aucune assurance",
  vdl_assurancedesadministrateurs: "Assurance accident des administrateurs non rémunérés et bénévoles",
  vdl_assurancedesbiens: "Assurance des biens",
  vdl_assuranceresponsabilitecivile: "Assurance en responsabilité civile",
  vdl_assuranceadministrateursetdirigeants: "Assurance administrateurs et dirigeants",
  vdl_nomdelacompagniedassurance: "Nom de la (des) compagnie(s) d'assurance",
  vdl_numerodelapolicedassurance: "Numéro de la (des) police(s) d'assurance",
  vdl_datedecheancedelapolicedassurance: "Date d'échéance de la (des) police(s) d'assurance",
  vdl_missionetobjectif: "Mission et objectifs",
  vdl_realitebesoinsoutien: "Explications",
  vdl_pointsdeservicealaval: "Points de service à Laval",
  vdl_siouiaquelendroit: "Si oui, à quel endroit (quartier, site ou adresse)",
  vdl_dansqueldomainedactivitevotreorganismeinter: "Quel est le principal domaine d'activité de votre organisation?",
  vdl_siautresprecisez: "Si autres, précisez",
  vdl_principauxserviceouactivites: "Principaux services ou activités",
  vdl_desregroupementsetoudesorganismes: "Regroupements et/ou organismes",
  vdl_territoiresdesservisparlorganisme2: "Territoires desservis par l'organisation",
  vdl_siailleursprecisez: "Si ailleurs, précisez",
  vdl_nombredeparticipantsauxactivites: "Nombre de participants aux activités",
  vdl_typedeclientele: "Quel type de clientèle votre organisation dessert-il?",
  vdl_prescolaire0a4ans: "Préscolaire (0 à 4 ans)",
  vdl_enfants5a12ans: "Enfants (5 à 12 ans)",
  vdl_adolescents13a17ans: "Adolescents (13 à 17 ans)",
  vdl_adultes18a64ans: "Adultes (18 à 64 ans)",
  vdl_aines65ansetplus65: "Aînés (65 ans et plus)",
  vdl_politiquedeverification: "Politique de vérification",
  vdl_entente: "Entente",
  vdl_codedeconduite: "Code de conduite",
  vdl_formationsurladoptiondecomportementsadequats: "Formation sur l'adoption de comportements adéquats",
  vdl_codedeconduitedelorganisation: "Code de conduite de l'organisation",
  vdl_codeetsignatureduncontratethique: "Code et signature d'un contrat éthique",
  vdl_verificationantecedentjudiciaire: "Vérification des antécédents judiciaires",
  vdl_mecanismedegestionderisqueencasdedoute: "Mécanisme de gestion de risque en cas de doute",
  vdl_utilisationdelaplateformejebenevoleca: "Utilisation de la plateforme Jebenevole.ca ",
  vdl_jeveuxplusdinformationacesujet: "Je veux plus d'information à ce sujet",
  vdl_nombrederencontresduca: "Nombre de réunions du conseil d'administration tenues au cours de la dernière année",
  vdl_nombredepresencesalaga: "Nombre de personnes présentes à l'assemblée générale annuelle (AGA)",
  vdl_datedeladerniereassembleegeneraleannuelle: "Date de la dernière assemblée générale annuelle (AGA)",
  vdl_nombredemembresactifsauseindelorganisme: "Nombre total de membres actifs de l'organisme",
  vdl_duneconcertation: "d'une concertation? Si oui, précisez",
  vdl_dunregroupement: "d'un regroupement? Si oui, précisez",
  vdl_dunefederation: "d'une fédération? Si oui, précisez",
  vdl_produisezvousannuellementdesprevisionsbudgeta: "Votre organisme produit annuellement des prévisions budgétaires.",
  vdl_vosderniersetatsfinanciersontilsfaitlobjet: "Vos derniers états financiers ont fait l'objet d'une vérification.",
  vdl_datedefindevotreexercicefinancierannuel: "Date de fin de votre exercice financier",
  vdl_audit: "Audit",
  vdl_missiondexamen: "Mission d'examen",
  vdl_verificationcomptable: "Vérification comptable",
  vdl_datedeladeclarationaureq: "Date de constitution",
  vdl_admissibiliterenouvellement: "",
  vdl_resolutionduconseildadministration: "Résolution du conseil d'administration",
  vdl_reglementsgeneraux: "Règlements généraux",
  vdl_procesverbauxdesagaetags: "Procès-verbaux des AGA et AGS",
  vdl_lettrespatentesetcharte: "Lettres patentes et charte",
  vdl_rapportdactivite: "Rapport d’activité et autres documents",
  vdl_etatsfinanciers: "États financiers les plus récents",
  vdl_numerodebienfaisance: "Numéro de bienfaisance",
  vdl_fichierdadmissibilite_Admissiblite_vdl_admisibilite: ""
};

const publicSpaceDisplayNames: DisplayNames<IncidentPublicSpaceDetailsRow> = {
  vdl_espacemunicipalid: "",
  vdl_name: "Nom de l'activité / événement",
  reservations: "",
};

const publicSpaceReservationDisplayNames: DisplayNames<IncidentPublicSpaceReservationRowBase> =
  {
    vdl_courriel: "Courriel",
    vdl_debutdelareservation: "Début réservation",
    vdl_findelareservation: "Fin réservation",
    vdl_ndetelephoneprincipal: "N° de téléphone principal",
    vdl_prenom: "Prénom",
    vdl_nom: "Nom",
    vdl_nombredeparticipants: "Nombre de participants",
    _vdl_nomdusiteareserver_value: "Nom du site à réserver",
    _vdl_sousplateau_value: "Sous-plateau",
    vdl_titre: "Titre",
  };

const specialEventsGeneralDisplayNames: DisplayNames<IncidentSpecialEventsDetailsGeneralRow> =
  {
    vdl_evenementspecialid: "",
    vdl_lieudelevenement: "Lieu de l'événement",
    vdl_precisionsurlelieu: "Précision sur le lieu",
    vdl_siautreprecisezlieu: "Si autre, précisez",
    vdl_encasdintemperieslevenementest: "En cas d'intempéries, l'événement est:",
    vdl_siremisle: "Si remis, le",
    dates: "Dates"
  };
const specialEventDisplayNames: DisplayNames<
  Omit<IncidentSpecialEventDetailsRow, keyof IncidentSpecialEventsDetailsGeneralRow>
> = {
  vdl_nomdelevenement: "Nom de l'événement",
  vdl_naturedelevenement: "Nature de l'événement",
  vdl_siautreprecisez: "Si autre, précisez la nature",
  vdl_descriptiondelevenement: "Description de l'événement",
  vdl_rayonnementdelevenement: "Rayonnement de l'événement",
  vdl_nouvelledemande: "Nouvelle demande",
  vdl_demanderecurrente: "Demande récurrente",
  vdl_sireccurentdatedeladerniereedition: "Si récurrent, date de la dernière édition",
  vdl_nombredeparticipantsetdevisiteursattendus: "Nombre de participants et de visiteurs attendus",
  vdl_clienteleviseeparlevenement: "Clientèle visée par l'événement",
  vdl_sispecifiqueprecisez: "Si spécifique, précisez",
  vdl_renseignementssupplementaires: "Renseignements supplémentaires (demande d'aménagement électrique et demandes particulières à l'attention du répondant municipal)",
  vdl_engagementloisetreglement: "L'organisation s'engage à respecter les lois et la règlementation en vigueur ainsi qu'à tout mettre en œuvre afin de se conformer aux exigences du Cadre de gestion des événements spéciaux de la Ville de Laval - Volet partenaires.",
  vdl_engagementequiteetinclusion: "Accessibilité universelle : Dans un but d'équité et d'inclusivité, l'organisation s'engage à tout mettre en œuvre afin de permettre à toute personne de participer à des activités de façon autonome et de vivre une expérience de qualité équivalente.",
  vdl_engagementdeveloppementdurable: "L'organisation s'engage à adhérer aux principes du développement durable et à collaborer avec la ville de Laval dans la mise en application de mesures écoresponsables (voir Engagement éco-citoyen en annexe 4 du Cadre de gestion des événements spéciaux).",
  vdl_responsabilitedumaterielprete: "L'organisation est responsable du matériel qui lui est prêté et s'engage à remettre les lieux dans l'état qu'ils étaient avant la tenue de l'événement. Tout bris ou perte devra être signalé au répondant municipal et des frais peuvent être applicables.",
  vdl_engagementhabitudessaines: "Saines habitudes de vie : L'organisation s'engage à faciliter l'accès aux participants à une alimentation saine, équilibrée, variée et sécuritaire et à favoriser les transports actifs pour se rendre au site de l'événement.",
  vdl_engagementsecurite500participants: "Pour les activités de plus de 500 personnes, le requérant assure la sécurité des participants par la présence de bénévoles affectés au maintien de l'ordre ou par la présence d'une agence de sécurité reconnue."
};

  const specialEventsDateDisplayNames: DisplayNames<IncidentSpecialEventsDateBase> =
  {
    vdl_description: "Description",
    vdl_dateetheurededebut: "Date et heure de début",
    vdl_dateetheuredefin: "Date et heure de fin"
  };
  
export {
  demandDisplayNames,
  infoRequestDisplayNames,
  standardEquipmentDisplayNames,
  fundraiserDisplayNames,
  electronicPanelsDisplayNames,
  activitiesCalendarDisplayNames,
  televisionDisplayDisplayNames,
  websiteDisplayDisplayNames,
  prismeDisplayNames,
  admissibilityDisplayNames,
  publicSpaceDisplayNames,
  publicSpaceReservationDisplayNames,
  specialEventsGeneralDisplayNames,
  specialEventDisplayNames, 
  specialEventsDateDisplayNames,
  filmingDisplayNames
};
